import { combineReducers } from "@reduxjs/toolkit";
import adminConsoleSidebarReducer from "./adminConsoleSidebar";

const sidebarsReducers = combineReducers({
  adminConsoleSidebar: adminConsoleSidebarReducer,
});

export default sidebarsReducers;
